import React from 'react';
import Select from 'react-select';
import { selectStyle } from "../../../helpers/utils/StyleUtils";

interface Option {
    value: any;
    label: string;
}

interface SelectFieldProps {
    label?: string;
    required?: boolean;
    value?: Option | null | any;
    options: Option[];
    onChange?: (selectedOption: Option | null) => void;
    placeholder?: string;
    isLoading?: boolean;
    labelPosition?: 'left' | 'right' | 'top';
    isMulti?: boolean;
    isDisabled?: boolean;
    icon?: any
    inputIcon?: any
    hideLabel?: boolean;
    className?: any;
    hideClearIcon?: boolean;
    labelClassName?:any
}

const SelectField: React.FC<SelectFieldProps> = ({
                                                     label,
                                                     required = false,
                                                     value,
                                                     options,
                                                     onChange,
                                                     placeholder = 'Select...',
                                                     isLoading = false,
                                                     labelPosition = "",
                                                     isMulti = false,
                                                     isDisabled = false,
                                                     icon,
                                                     inputIcon,
                                                     hideLabel,
                                                     className,
                                                     hideClearIcon = false,
                                                     labelClassName
                                                 }) => {

    const renderLabel = () => (
        <div className={`text-surface-0 flex items-center ${labelClassName}`}>{required ? `*${label}` : label}
            {icon && <span className="ml-2">{icon}</span>}
        </div>
    );

    return (
        <>
            {labelPosition !== "top" ?
                <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                    {!hideLabel && (
                        <div className={`col-span-3 sm:mt-2 lg-mt-0 mt-2 flex items-center font-normal ${labelClassName}`}>
                            {renderLabel()}
                        </div>
                    )}

                    <div className={`${className ?? "col-span-9 mt-3"}`}>
                        <Select
                            onChange={onChange}
                            value={value}
                            isClearable={!hideClearIcon}
                            options={options}
                            styles={selectStyle}
                            placeholder={placeholder}
                            isDisabled={isLoading || isDisabled}
                            required={required}
                            isMulti={isMulti}
                        />
                        {inputIcon && inputIcon}
                    </div>
                </div>
                :
                <div className="col-span-4">
                    {renderLabel()}
                    <Select
                        isDisabled={isLoading || isDisabled}
                        styles={selectStyle}
                        onChange={onChange}
                        value={value}
                        isClearable={!hideClearIcon}
                        options={options}
                        placeholder={placeholder}
                        required={required}
                        isMulti={isMulti}
                    />
                </div>
            }
        </>
    );
};


export default SelectField;
